import React, { useCallback } from 'react';
import { useSelector } from '@xstate/react';

import { useServices } from '../../hooks';

import { billingFiltersSelectors } from '../../machines/billingFilters';
import Filters from '../../components/Filters';

import { FilterType } from '../../machines/billingFilters';

import { DateFilterTabType } from '../../machines/billingFilters/types';

const FiltersContainer = () => {
  const { billingFiltersService } = useServices();

  const isOpen = useSelector(
    billingFiltersService,
    billingFiltersSelectors.getFiltersVisibility
  );

  const filtersSettings = useSelector(
    billingFiltersService,
    billingFiltersSelectors.getInlineFiltersValues
  );

  const filtersSections = useSelector(
    billingFiltersService,
    billingFiltersSelectors.getFiltersSections
  );

  const isFilteringApplied = useSelector(
    billingFiltersService,
    billingFiltersSelectors.isFilteringApplied
  );

  const toggleFilters = useCallback(() => {
    if (isOpen) {
      billingFiltersService.send('CLOSE_FILTERS');
    } else {
      billingFiltersService.send('OPEN_FILTERS');
    }
  }, [isOpen]);

  return (
    <>
      <Filters
        isOpen={isOpen}
        isFilteringApplied={isFilteringApplied}
        filtersSettings={filtersSettings}
        filtersSections={filtersSections}
        onToggleFilters={toggleFilters}
        onDateTypeChange={(tabType: DateFilterTabType) =>
          billingFiltersService.send('CHANGE_DATE_TAB', { tabType })
        }
        onCloseFilters={() => {
          if (isOpen) {
            billingFiltersService.send('CLOSE_FILTERS');
          }
        }}
        onToggleSection={(sectionName: FilterType) =>
          billingFiltersService.send('TOGGLE_SECTION', { sectionName })
        }
        onUpdateFilter={(filter, value) =>
          billingFiltersService.send('UPDATE_FILTER', {
            filter,
            value,
          })
        }
        onClear={() => billingFiltersService.send('CLEAR_FILTERS')}
        onApply={() => billingFiltersService.send('APPLY_FILTERS')}
      />
    </>
  );
};

export default FiltersContainer;
